module.exports = __webpack_public_path__ + "static/media/2.20_preview.b681f0a8.png";